<input #fileInput hidden type="file" (change)="selectedFile($event)"/>

<div class="display">
    <image-cropper
            [imageURL]="url"
            [imageChangedEvent]="imageChangedEvent"
            [maintainAspectRatio]="true"
            format="png"
            roundCropper="true"
            (imageCropped)="imageCropped($event)"
    ></image-cropper>

    <div class="buttons">
        <div class="left">
            <button mat-button (click)="fileInput.click()" i18n>SELECT FILE</button>
        </div>
        <div class="right">
            <button color="primary" mat-button (click)="save()" i18n>SAVE</button>
            <button mat-button (click)="cancel()" i18n>CANCEL</button>
        </div>
    </div>
</div>

